import { Card, CardContent, styled } from "@mui/material";

import { CatalystIcon } from "@citrine/atoms/icons";

import { Form, TextField } from "#src/components/form";

export const CATALYST_EXPANDED_CLASS = "expanded";

export const PanelWrapper = styled("div")(({ theme }) => ({
  bottom: 0,
  // ensure box-shadow only expands to the right
  clipPath: `polygon(0 0, 100vw 0, 100vw 100%, 0 100%)`,
  display: "flex",
  flexDirection: "column",
  left: 0,
  marginLeft: theme.spacing(-theme.layout.CATALYST_WIDTH),
  position: "fixed",
  top: theme.spacing(theme.layout.NAVBAR_HEIGHT),
  transition: theme.transitions.create(["box-shadow", "margin"]),
  width: theme.spacing(theme.layout.CATALYST_WIDTH),
  zIndex: theme.zIndex.catalyst,

  [`&.${CATALYST_EXPANDED_CLASS}`]: {
    boxShadow: `0px 0px ${theme.spacing(1)} ${theme.spacing(
      -0.25,
    )} ${theme.palette.grey[600]}`,
    marginLeft: 0,
  },

  [`@media (min-width: ${theme.spacing(
    theme.layout.CATALYST_WIDTH + theme.layout.SCREEN_BREAK_1,
  )})`]: {
    [`&.${CATALYST_EXPANDED_CLASS}`]: {
      boxShadow: `1px 0px 0px ${theme.palette.grey[300]}`,
    },
  },
}));

export const CatalystExpanded = `${PanelWrapper}.${CATALYST_EXPANDED_CLASS}`;

export const Catalyst = styled(Form)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
}) as typeof Form;

export const Panel = styled(Card)({
  background: "transparent",
  border: "none",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
});

export const Content = styled(CardContent)(({ theme }) => ({
  background: theme.palette.common.white,
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: theme.spacing(2),
  overflowY: "auto",
  padding: theme.spacing(2),
  scrollBehavior: "smooth",
}));

export const ExpandButton = styled("div")(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.palette.info.main,
  clipPath: "polygon(0 0, 100% 32px, 100% calc(100% - 32px), 0 100%)",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  left: 0,
  padding: theme.spacing(5, 0.5),
  position: "fixed",
  top: theme.spacing(theme.layout.NAVBAR_HEIGHT + 11),
  zIndex: theme.zIndex.catalyst - 1,
  opacity: 1,

  // Animation when opening/closing the panel
  transition: theme.transitions.create(["opacity"]),

  [`&.${CATALYST_EXPANDED_CLASS}`]: {
    opacity: 0,
  },
  /**
   * if we decide to match the HelpScout icon colors, uncomment the following
  backgroundColor: "rgb(0, 128, 182)",
  ":hover": {
    backgroundColor: "rgb(0, 120, 174)",
  },
  */
}));

export const ButtonIcon = styled(CatalystIcon)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const Input = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    padding: theme.spacing(0, 1.25),

    "&.MuiInputBase-multiline": {
      lineHeight: "1.2",
    },
  },
}));
